import React from "react";
import { MousePointerClick, LayoutPanelTop, Rows3 } from "lucide-react";
import Toggle from "./Toggle";

const GROUPS = [
  { type: "button", labelKey: "featuresButtons", Icon: MousePointerClick },
  { type: "section", labelKey: "featuresSections", Icon: LayoutPanelTop },
  { type: "tab", labelKey: "featuresTabs", Icon: Rows3 },
];

/**
 * Feature switches for one page, grouped by registry type (button/section/tab).
 * Features are opt-IN: no row in enabledFeatures = the feature is off.
 */
const FeatureToggleList = ({ page, enabledFeatures, onToggleFeature, theme, language, t, disabled = false }) => {
  const features = page?.features || [];
  if (!features.length) return null;

  const textColor = theme === "dark" ? "#cbd5e1" : "#334155";
  const headColor = theme === "dark" ? "#94a3b8" : "#64748b";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {GROUPS.map(({ type, labelKey, Icon }) => {
        const group = features.filter((f) => f.type === type);
        if (!group.length) return null;
        return (
          <div key={type}>
            <div style={{
              display: "flex", alignItems: "center", gap: "6px",
              fontSize: "11px", fontWeight: 700, letterSpacing: "0.06em",
              textTransform: "uppercase", color: headColor, marginBottom: "8px",
            }}>
              <Icon size={12} />
              {t[labelKey]}
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill,minmax(210px,1fr))",
              gap: "6px 16px",
            }}>
              {group.map((feature) => {
                const enabled = !!enabledFeatures?.[feature.key];
                return (
                  <label
                    key={feature.key}
                    style={{
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      gap: "10px", padding: "7px 10px", borderRadius: "10px",
                      cursor: "pointer", userSelect: "none",
                      transition: "background 0.15s ease",
                      background: enabled
                        ? (theme === "dark" ? "rgba(16,185,129,0.08)" : "rgba(16,185,129,0.06)")
                        : "transparent",
                    }}
                  >
                    <span style={{ fontSize: "13px", color: textColor, fontWeight: enabled ? 600 : 400 }}>
                      {feature.labels?.[language] || feature.labels?.en || feature.key}
                    </span>
                    <Toggle
                      theme={theme}
                      checked={enabled}
                      onChange={(next) => onToggleFeature(page.key, feature.key, next)}
                      disabled={disabled}
                    />
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeatureToggleList;
